module.exports = __webpack_public_path__ + "img/oven-fried-sole.84ce0c52.jpg";